<template>
  <div class="artists__body">
    <div v-for="(column, index) in columns" :key="`column-${index}`" class="artists__body__column">
      <router-link
        v-for="(item, index) in column"
        :key="`item-${index}`"
        class="artists__body__column_item"
        :to="{ path: `/artists/${item.slug}` }"
      >
        <span
          class="artists__body__column_name"
          :class="{ 'artists__body__column_name--disabled': !item.hasArtworks }"
        >
          {{ item.reversed_full_name }}
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: ["columns"],
};
</script>

<style lang="scss" scoped>
.artists__body {
  display: flex;
  justify-content: space-between;
  gap: 0 12px;
  width: 90%;
  margin-top: 70px;
  @media only screen and (max-width: $xs) {
    width: 100%;
    margin-top: 40px;
    display: block;
    text-align: center;
  }

  &__column {
    &_item {
      display: block;
      text-decoration: none;
      @media screen and (max-width: $xs) {
        text-align: left;
      }
    }

    &_name {
      font-size: 18px;
      line-height: 1.55;
      &:hover {
        text-decoration: underline;
        cursor: pointer;
      }
      &--disabled {
        color: $grey;
      }
    }
  }
}
</style>

